import { io } from 'socket.io-client';
import API_CONFIG from '../config/api';

class SocketService {
  constructor() {
    this.socket = null;
    this.connected = false;
  }

  connect(token) {
    if (this.socket?.connected) {
      return this.socket;
    }

    this.socket = io(API_CONFIG.SOCKET_URL, {
      auth: {
        token
      },
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 5
    });

    this.socket.on('connect', () => {
      console.log('Socket connected');
      this.connected = true;
    });

    this.socket.on('disconnect', () => {
      console.log('Socket disconnected');
      this.connected = false;
    });

    this.socket.on('connect_error', (error) => {
      console.error('Socket connection error:', error);
      this.connected = false;
    });

    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.connected = false;
    }
  }

  // Gửi tin nhắn
  sendMessage(message, receiverId, callback, imageUrl = null) {
    if (!this.socket) return;
    this.socket.emit('send-message', { message, receiverId, imageUrl }, callback);
  }

  // Lắng nghe tin nhắn mới
  onNewMessage(callback) {
    if (!this.socket) return;
    this.socket.on('new-message', callback);
  }

  // Lấy danh sách user đã chat (admin only)
  getChatUsers(callback) {
    if (!this.socket) return;
    this.socket.emit('get-chat-users', callback);
  }

  // 获取自己的客服未读数（user 端）
  getMyUnread(callback) {
    if (!this.socket) return;
    this.socket.emit('get-my-unread', callback);
  }

  // Đánh dấu đã đọc
  markAsRead(userId) {
    if (!this.socket) return;
    this.socket.emit('mark-as-read', { userId });
  }

  // Typing indicators
  startTyping(userId) {
    if (!this.socket) return;
    this.socket.emit('typing', { userId });
  }

  stopTyping(userId) {
    if (!this.socket) return;
    this.socket.emit('stop-typing', { userId });
  }

  onUserTyping(callback) {
    if (!this.socket) return;
    this.socket.on('user-typing', callback);
  }

  onUserStopTyping(callback) {
    if (!this.socket) return;
    this.socket.on('user-stop-typing', callback);
  }

  // Remove listeners
  removeAllListeners() {
    if (!this.socket) return;
    this.socket.removeAllListeners();
  }
}

export default new SocketService();
